import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getemployee_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "employeeevaluation", ...action.payload }),
		);
		yield put({
			type: types.GET_EMPLOYEE_EVALUATION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EMPLOYEE_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* getemployee_evaluationWatcherSaga() {
	yield takeLatest(
		types.GET_EMPLOYEE_EVALUATION_START,
		getemployee_evaluationHandlerSaga,
	);
}

//create

//delete

function* deleteemployee_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("employeeevaluation", action.payload),
		);
		yield put({
			type: types.DELETE_EMPLOYEE_EVALUATION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_EMPLOYEE_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* deleteemployee_evaluationWatcherSaga() {
	yield takeLatest(
		types.DELETE_EMPLOYEE_EVALUATION_START,
		deleteemployee_evaluationHandlerSaga,
	);
}

//update
